export default "__VITE_ASSET__0472d361__"